import { render, staticRenderFns } from "./EventPromotionPanel.vue?vue&type=template&id=3a7ba1b1&scoped=true"
import script from "./EventPromotionPanel.vue?vue&type=script&lang=js"
export * from "./EventPromotionPanel.vue?vue&type=script&lang=js"
import style0 from "./EventPromotionPanel.vue?vue&type=style&index=0&id=3a7ba1b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7ba1b1",
  null
  
)

export default component.exports